<template>
    <div class="mymachines">
        <b-container fluid>
            <b-row>
                <b-col cols="4">
					<div v-if="schede.length > 5" class="mtop10 filtro">
						Filter:
						<input v-debounce:500="filtroSchedeChanged" type="text" />
					</div>
                    <div v-else style="height: 30px; margin: 10px;">&nbsp;</div>
                    <b-row v-for="machine in schede" :key="machine.codice" >
                        <b-col>
                            <SchedaMacchina :m="machine" :info="true" buttontext="MORE INFO" route="pinfomacchina" :key="upd"/>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="8">
                    <div style="height: 40px; margin: 10px;">&nbsp;</div>
                    <b-card>
                        <b-row>
                            <b-col>
                                <div class="title">Last Updates</div>
                                <OpenPoints :noAdd="true" :filtro="kfiltro" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="title">Open Points - Status</div>
                                <OpenPointsStatus :info="false" :filtro="kfiltro" />
                            </b-col>
                            <b-col>
                                <div class="title">Expiring Issues</div>
                                <ExpiringIssues :filtro="kfiltro" :style="`height: 350px`"/>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { API } from "@/api.js";
import OpenPoints from "@/components/OpenPoints.vue";
import SchedaMacchina from "@/components/SchedaMacchina.vue";
import OpenPointsStatus from "@/components/OpenPointsStatus.vue";
import ExpiringIssues from "@/components/ExpiringIssues.vue";

export default {
    name: "PIMyMachines",
    components: {
        OpenPoints,
        SchedaMacchina,
        OpenPointsStatus,
        ExpiringIssues,
    },
    data: function () {
        return {
            owners: [{ value: "Marsilli", text: "Marsilli" }, { value: "Customer", text: "Customer" }],
            priorities: [],
            phases: [],
            categories: [],
            states: [],
            schede: [],
            upd: 0,
        }
    },
    async mounted(){
        this.$store.commit("machine", null);
        let unitNames = await API.getUnitNames();
        console.log("unitNames",unitNames)
		let data = await API.getUnits(false,this.section);
        console.log("data",data)
        let pi_units = await API.getPrInUnits(this.section);
        console.log("pi_units",pi_units)
        pi_units = pi_units.map(u => u.unit_code)
        // console.log("pi_units",pi_units)
		this.schede = data.filter(u => pi_units.includes(u.code)).map((d) => ({
			client: d.client_code,
			nome: d.name,
			codice: d.code,
			location: d.location,
			img: d.img,
			macchina: d.macchina,
			descr: d.descr,
			delivered: d.delivered,
			label_info: d.label_info,
			upd: 0,
			nomepers: (unitNames.find(u => u.code==d.code) || {}).name || d.name,
			locationpers: (unitNames.find(u => u.code==d.code) || {}).location || d.location
		})); // upd serve per l'aggiornamento delle immagini
        console.log("schede",this.schede)

        this.priorities = (await API.getPriorities()).map((p) => ({value:p.level, text:p.description}));
        this.phases = (await API.getPhases(this.section)).map((p) => ({value:p.id, text:p.descr}));
        this.categories = (await API.getCategories()).map((p) => ({value:p.id, text:p.descr}));
        this.states = (await API.getStates()).map((p) => ({value:p.id, text:p.descr}));

        console.log("issues",this.issues)
		this.$nextTick(async () => {
			let k = 1;
			for (let s of this.schede) {
				s.image = "/images/units/" + s.img;
				s.upd = k++;
                this.upd++
			}
            // this.machine.image = "/images/units/" + this.machine.img;
            // this.machine.upd = k++;
		});
    },
    computed: {
        kfiltro(){
            return this.schede.map(s => s.codice);
        },
        section(){
            return this.$store.getters.section
        },
    },
    methods: {
    }
}

</script>
<style scoped>
div.title {
    text-align: left;
    font-weight: 700;
}
div.mymachines button {
	background-color: #9a240d !important;
	border-color: #9a240d !important;
	margin-bottom: 10px;
}
div.mymachines button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.mymachines button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.mymachines {
    background-color: #d3d3d3;
    overflow: auto;
    height: 87vh;
    max-height: 87vh;
}
</style>
